import { size } from '@styles/theme'
import styled from '@emotion/styled'

import { ToggleOptions, ToggleSection, ToggleTitle } from './SharedNearbyFilterComponents'
import { PiArrowsDownUpBold, PiArrowsHorizontalBold, PiArrowsVerticalBold } from 'react-icons/pi'
import { ToggleButton } from '@elements/form_elements/ToggleButton'
import { NearbyActiveIndicator } from './NearbyActiveIndicator'

const StyledToggleButton = styled(ToggleButton)`
  padding-top: ${size(2)};
  padding-bottom: ${size(2)};
`

const PositionFilterSection = ({ value, onChange, isInactive }) => {
  return (
    <ToggleSection>
      <ToggleTitle>
        Position
        <NearbyActiveIndicator isActive={value instanceof Set && value.size > 0} />
      </ToggleTitle>
      <ToggleOptions style={{ filter: isInactive && 'grayscale(100%)' }} onChange={onChange}>
        <StyledToggleButton
          value='top'
          name='position'
          selected={value?.has?.('top')}
          onChange={(e) => onChange(e, 'position', 'top')}>
          🍆&nbsp;&nbsp;Top
        </StyledToggleButton>
        <StyledToggleButton
          value='verse_top'
          name='position'
          selected={value?.has?.('verse_top')}
          onChange={(e) => onChange(e, 'position', 'verse_top')}>
          <PiArrowsVerticalBold size={size(1.9)} style={{ marginRight: -5 }} />🍆&nbsp;&nbsp;Verse Top
        </StyledToggleButton>
        <StyledToggleButton
          value='bottom'
          name='position'
          selected={value?.has?.('bottom')}
          onChange={(e) => onChange(e, 'position', 'bottom')}>
          🍑&nbsp;&nbsp;Bottom
        </StyledToggleButton>
        <StyledToggleButton
          value='verse_bottom'
          name='position'
          selected={value?.has?.('verse_bottom')}
          onChange={(e) => onChange(e, 'position', 'verse_bottom')}>
          <PiArrowsVerticalBold size={size(1.9)} style={{ marginRight: -5 }} />🍑&nbsp;&nbsp;Verse Btm
        </StyledToggleButton>
        <StyledToggleButton
          value='verse'
          name='position'
          selected={value?.has?.('verse')}
          onChange={(e) => onChange(e, 'position', 'verse')}>
          <PiArrowsDownUpBold size={size(1.9)} />&nbsp;&nbsp;Verse
        </StyledToggleButton>
        <StyledToggleButton
          value='side'
          name='position'
          selected={value?.has?.('side')}
          onChange={(e) => onChange(e, 'position', 'side')}>
          <PiArrowsHorizontalBold size={size(1.9)} />&nbsp;&nbsp;Side
        </StyledToggleButton>
      </ToggleOptions>
    </ToggleSection>
  )
}

export { PositionFilterSection }
